import request from '../utils/request';

//订单列表
export function orderList(limit,page,order_type,keyword,status,pay_type,begin_time,end_time) {
    return request.post('/api/contract_order_list',{"limit":limit,"page":page,"order_type":order_type,"keyword":keyword,"status":status,"pay_type":pay_type,"begin_time":begin_time,"end_time":end_time})
}
//我发起的合同 支付订单取消支付
export function cancelPayment(id) {
    return request.post('/api/contract_order_cancel_pay',{"id":id})
}
//获取订单二维码
export function get_QR_code(id) {
    return request.post('/api/contract_order_geth5qrcode',{"id":id})
}
//查看短信状态
export function SMS_status(id) {
    return request.post('/api/contract_pay_sms_scan_status',{"id":id})
}
